import { Button } from "@mui/material";
import * as React from "react";
import ModeEditIcon from "@mui/icons-material/ModeEdit";

const BottomToolbarSetting = (props) => {
  const { type, item, onChangeTable, onImageDimensionChange, ...others } =
    props;

  const handeleWidthChange = (e) => {
    onImageDimensionChange({
      height: item?.imageSetting?.height,
      width: e.target.value,
    });
  };

  const handeleHeightChange = (e) => {
    onImageDimensionChange({
      width: item?.imageSetting?.width,
      height: e.target.value,
    });
  };

  return (
    <>
      {type === "table" && (
        <div>
          <Button
            onClick={onChangeTable}
            sx={{
              padding: "10px",
              height: "40px",
              cursor: "pointer",
              background: "#2b64ef",
              ":hover": { background: "#14203e" },
              display: "none", // temporary none
            }}
            startIcon={<ModeEditIcon />}
          >
            Ndrysho te dhenat
          </Button>
        </div>
      )}
      {type === "image" && (
        <>
          gjeresi:{" "}
          <input
            style={{
              marginLeft: "3px",
              marginRight: "3px",
              width: "60px",
            }}
            onChange={handeleWidthChange}
            value={item?.imageSetting?.width}
          ></input>
          lartesi:
          <input
            style={{ marginLeft: "3px", width: "60px" }}
            onChange={handeleHeightChange}
            value={item?.imageSetting?.height}
          ></input>
        </>
      )}
      {}
    </>
  );
};

export default BottomToolbarSetting;
